import TagsManager from './TagsManager'

export default TagsManager
